import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function StructurePage() {
  const { t } = useTranslation('structure');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CookieBanner />

      <section className="pt-32 pb-44">
        <div className="max-w-[1280px] mx-auto px-10">
          <div className="text-center mb-32">
            <span className="inline-block bg-[#1BCDFF]/10 text-[#0A2D50] text-xs uppercase tracking-wider px-4 py-2 rounded-full mb-5">
              {t('label')}
            </span>
            <h1
              className="text-5xl font-bold text-[#0A2D50] mb-6"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {t('title')}
            </h1>
            <p className="text-lg text-gray-600 max-w-[640px] mx-auto">
              {t('subtitle')}
            </p>
          </div>

          {/* HoldCo */}
          <div className="flex justify-center mb-8">
            <div className="w-[420px] h-40 bg-white border-2 border-[#1BCDFF] rounded-2xl flex items-center justify-center relative">
              <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center bg-[#1BCDFF]/10 rounded-lg">
                <i className="ri-building-line text-xl text-[#1BCDFF]"></i>
              </div>
              <div className="text-center">
                <h2 className="text-3xl font-semibold text-[#0A2D50] mb-2">
                  {t('holdco.name')}
                </h2>
                <p className="text-sm text-gray-600">{t('holdco.type')}</p>
              </div>
            </div>
          </div>

          {/* Connecting Line */}
          <div className="flex justify-center mb-8">
            <div className="w-0.5 h-20 bg-[#1BCDFF]/30"></div>
          </div>

          {/* Participations */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-32">
            {/* S4Chain */}
            <div className="bg-white border-[1.5px] border-[#1BCDFF] rounded-2xl p-12 relative hover:shadow-lg transition-all duration-300">
              <span className="absolute top-4 right-4 bg-green-100 text-green-700 text-xs font-medium px-3 py-1 rounded-full">
                {t('participations.s4chain.status')}
              </span>
              <div className="h-20 flex items-center justify-center mb-6">
                <div className="w-16 h-16 bg-[#1BCDFF]/10 rounded-xl flex items-center justify-center">
                  <i className="ri-links-line text-3xl text-[#1BCDFF]"></i>
                </div>
              </div>
              <h3 className="text-2xl font-semibold text-[#0A2D50] mb-3">
                {t('participations.s4chain.name')}
              </h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                {t('participations.s4chain.description')}
              </p>
              <a
                href="https://s4chain.readdy.co"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[#1BCDFF] hover:text-[#1EB7EC] transition-colors inline-flex items-center gap-2 cursor-pointer"
              >
                {t('participations.s4chain.link')}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Placeholder 1 */}
            <div className="bg-white border-2 border-dashed border-gray-300 rounded-2xl p-12 flex flex-col items-center justify-center">
              <i className="ri-add-line text-4xl text-gray-300 mb-4"></i>
              <p className="text-lg text-gray-400">{t('participations.placeholder')}</p>
            </div>

            {/* Placeholder 2 */}
            <div className="bg-white border-2 border-dashed border-gray-300 rounded-2xl p-12 flex flex-col items-center justify-center">
              <i className="ri-add-line text-4xl text-gray-300 mb-4"></i>
              <p className="text-lg text-gray-400">{t('participations.placeholder')}</p>
            </div>
          </div>

          {/* Future PropCo */}
          <div className="flex justify-center">
            <div className="w-[480px] h-32 bg-[#F2F4F5] border-2 border-dashed border-gray-300 rounded-2xl flex flex-col items-center justify-center">
              <h3 className="text-xl font-medium text-gray-500 mb-2">
                {t('future.title')}
              </h3>
              <p className="text-sm text-gray-400">{t('future.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}